/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:52
 */
import Column from './Column';
import ColorPicker from '../utils/ColorPicker';

class ColorColumn extends Column {
  constructor(params) {
    super(params);
    this.init();
  }

  init() {
    this.picker = new ColorPicker(this.$root.get(0));

    /*for (let i = 0; i < $elements.length; i++) {
      new ColorPicker($($elements[i]).find('input'), {
        onUpdate: (hex) => { $($elements[i]).find('.btn').css('background-color', hex); }
      });
    }*/
  }
}

export default ColorColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/ColorColumn.js